<!--  -->
<template>
    <div class="shijian">
        <!-- <img src="../assets/images/banner2.png" alt="" class="banner"> -->
        <div class="menu">
            <img :src="activeId==item.id?item.activeUrl:item.url" alt="" v-for="(item,index) in list" :key="index" @click="choose(item.id)">
        </div>
        <div class="content">
            <img :src="list[activeId-1].titleUrl" alt="">
            <span @click="goDetail">从“灵性”到“儒雅”——打造个性美育闭环  涂抹学生生命底色</span>
            <span>京蒙两地再携手 共谱教育新篇章——顺义一中与内蒙古巴林左旗开展业务培训交流活动丨支教故事 </span>
            <span>京蒙协作结硕果 对口帮扶显真情——察右后旗教育京蒙协作记实</span>
            <span>首都师范大学“双优云桥”项目助力受援地教师教育教学能力提升——案例</span>
            <span>扎实落实跟岗研修工作 促进区域教育均衡发展——西城区教育研修学院承接内蒙古巴彦淖尔教研员跟岗研修工作纪要</span>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeId:1,
                list: [{
                        id: 1,
                        url: require("../assets/shijian/04.png"),
                        activeUrl: require("../assets/shijian/04_active.png"),
                        titleUrl:require("../assets/shijian/04_title.png")
                    },
                    {
                        id: 2,
                        url: require("../assets/shijian/02.png"),
                        activeUrl: require("../assets/shijian/02_active.png"),
                        titleUrl:require("../assets/shijian/02_title.png")
                    },
                    {
                        id: 3,
                        url: require("../assets/shijian/03.png"),
                        activeUrl: require("../assets/shijian/03_active.png"),
                        titleUrl:require("../assets/shijian/03_title.png")
                    }],
                
            }
        },
        methods: {
            choose(id){
                this.activeId = id;
                
            },
            goDetail(){
                // window.open("http://www.moe.gov.cn/jyb_xwfb/xw_zt/moe_357/jjyzt_2022/2022_zt04/dianxing/xiangmu/shengshu/shengshu5th/202211/t20221116_992969.html")
                window.open('https://cnuzi-res.lezhireading.com/upload/2024/07/18/%E4%BB%8E%E2%80%9C%E7%81%B5%E6%80%A7%E2%80%9D%E5%88%B0%E2%80%9C%E5%84%92%E9%9B%85%E2%80%9D%E2%80%94%E2%80%94%E6%89%93%E9%80%A0%E4%B8%AA%E6%80%A7%E7%BE%8E%E8%82%B2%E9%97%AD%E7%8E%AF%20%20%E6%B6%82%E6%8A%B9%E5%AD%A6%E7%94%9F%E7%94%9F%E5%91%BD%E5%BA%95%E8%89%B2.pdf?OSSAccessKeyId=LTAI4G56MHdEKBUNCHeRnQVi&Expires=2352448381&Signature=xVqaPjNX0%2FmK%2FdHsJO9ZvMuJzHk%3D')
            }
        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url('./less/shijian.less');
</style>